// Import Dependencies
import { Button } from "components/ui";
import { PlusIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";

// ----------------------------------------------------------------------

export function Header({
  title,
  subtitle,
  actions,
  primaryActionLabel = "Add New",
  onPrimaryAction,
  hasPrimaryDropdown = false,
}) {
  return (
    <div className="relative z-94 mb-4 flex flex-row items-center justify-between gap-4 w-full">
      <div className="min-w-0 flex-1">
        <h1 className="text-xl md:text-2xl font-sans font-bold tracking-tight text-slate-900 dark:text-white">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-1 text-xs md:text-sm font-medium text-slate-500 dark:text-dark-300 max-sm:hidden">
            {subtitle}
          </p>
        )}
      </div>

      <div className="flex flex-row items-center justify-end gap-1.5 sm:gap-2 transition-all min-w-0 py-1">
        <div className="flex items-center gap-1.5 sm:gap-2">
          {actions}
        </div>

        {onPrimaryAction && (
          <div className="flex items-center shrink-0 rounded-xl overflow-hidden group/btn font-sans border-0 shadow-sm transition-all duration-300 ml-1">
            <Button
              color="primary"
              variant="filled"
              onClick={onPrimaryAction}
              className={clsx(
                "flex items-center gap-2 h-9 md:h-10 px-4 md:px-5 text-xs md:text-sm font-bold bg-primary hover:bg-primary-600 transition-colors",
                hasPrimaryDropdown ? "rounded-r-none border-r border-white/10" : "rounded-xl"
              )}
            >
              <PlusIcon className="h-4 w-4 stroke-[2.5px]" />
              <span className="whitespace-nowrap tracking-wide">{primaryActionLabel}</span>
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
